import styled, { css } from 'styled-components';
import { fieldBackgroundWhite, fieldBorder, grey26, metallicBlue, nightBlue } from '../../appComponents/cssConstants';

export const baseInputCss = css`
	border-radius: 8px;
	border: ${fieldBorder};
	background: ${fieldBackgroundWhite};
	font-size: 18px;
	height: 38px;
	line-height: 24px;
	width: 100%;
	color: ${metallicBlue};

	:disabled {
		cursor: not-allowed;
		border-color: rgb(168, 183, 199);
		background-color: rgb(248, 247, 243);
		opacity: 0.6;
	}
`;

export const StyledInput = styled.input`
	${baseInputCss}
`;

export const StyledDescription = styled.div`
	display: block;
	margin-top: 2px;
	font-size: 12px;
	color: #ff5151;
`;

export const StyledLabel = styled.label`
	display: block;
	margin-bottom: 4px;
	color: ${metallicBlue};
`;

export const StyledLegend = styled.legend<{ centred?: boolean }>`
	font-size: 13px;
	line-height: 16px;
	text-transform: uppercase;
	opacity: 0.65;
	color: ${grey26};
	margin: 0 0 9px 0;
	text-align: left;
	padding: 0 16px;
	width: 100%;
	font-weight: 400;
	${(props) =>
		props.centred === true
			? `margin: 0 auto 0px auto;
				color: ${nightBlue} !important;
				opacity: 1.0;
				text-transform: none;
				text-align: center;
				font-size: 28px;
				line-height: 1.4285714286;
				padding: 0;`
			: ''}
`;

export const Bold = styled.span`
	font-weight: bold;
`;
